export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5104.54ca6222.jpg";